import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, Search, DollarSign, Zap, ShieldCheck, MessageCircle, CheckCircle2 } from 'lucide-react';
export function WhyChooseUs() {
  const benefits = [{
    icon: <Wrench className="w-7 h-7" data-id="element-281" data-mp="q50ytnsrrth3" />,
    title: 'Diesel Specialists',
    description: 'Powerstroke and diesel is all we do — no generalists, no guesswork.'
  }, {
    icon: <Search className="w-7 h-7" data-id="element-282" data-mp="g6l3f8mply1s" />,
    title: 'Honest Diagnostics',
    description: 'We find the real problem and tell you straight — no upsells, no surprises.'
  }, {
    icon: <DollarSign className="w-7 h-7" data-id="element-283" data-mp="77zs9yjkhlb1" />,
    title: 'Fair Pricing',
    description: 'Premium expertise without dealership prices. Quotes you can trust.'
  }, {
    icon: <Zap className="w-7 h-7" data-id="element-284" data-mp="21kplee242qhd" />,
    title: 'Fast Turnaround',
    description: 'We respect your time. Most jobs in and out faster than the competition.'
  }, {
    icon: <ShieldCheck className="w-7 h-7" data-id="element-285" data-mp="1nedg77prbmcm" />,
    title: 'Reliable Repairs',
    description: 'Quality parts, proven methods, and repairs built to last for the long haul.'
  }, {
    icon: <MessageCircle className="w-7 h-7" data-id="element-286" data-mp="1x46rs8pwg1gv" />,
    title: 'Clear Communication',
    description: "You'll always know what's happening with your truck and why."
  }];
  return <section id="why-us" className="py-24 bg-dark relative overflow-hidden" data-id="element-287" data-mp="14fj466hoh005">
      {/* Decorative background accents */}
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-orange/5 blur-3xl" data-id="element-288" data-mp="zhhn1r3tbarb"></div>
      <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-orange/5 blur-3xl" data-id="element-289" data-mp="1ee8mg0dhkmgx"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-290" data-mp="19em6vka6qu4y">
        {/* Header */}
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-291" data-mp="2ps2o3cbk3rd4">
          <div className="inline-block px-4 py-1.5 bg-orange/10 border border-orange/20 rounded-full mb-6" data-id="element-292" data-mp="2ku150re4rs1n">
            <span className="text-orange text-sm font-bold uppercase tracking-widest" data-id="element-293" data-mp="2rxhel722mlha">
              Why Choose Us
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-display text-white mb-8 leading-tight" data-id="element-294" data-mp="2wur38khmyt42">
            Expert Powerstroke & Diesel Repair{' '}
            <span className="text-orange" data-id="element-295" data-mp="36u866u5i6swc">You Can Trust</span>
          </h2>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 text-left max-w-2xl mx-auto" data-id="element-296" data-mp="36sf6xzx7zayd">
            {['Ford Diesel Engine Experts.', 'Real Diagnostics. No Guesswork.', 'Fair Pricing. No Surprises.', 'Fast Service. Back on the Road Today.'].map(item => <li key={item} className="flex items-start text-white text-base md:text-lg font-medium" data-id="element-297" data-mp="2nvvub0n7j4x2">
                <CheckCircle2 className="w-6 h-6 text-orange flex-shrink-0 mr-3 mt-0.5" strokeWidth={2} data-id="element-298" data-mp="1qe5kjbcjfwa6" />
                <span data-id="element-299" data-mp="cj70beaqaf8a">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-300" data-mp="8jemon6h9iw2">
          {benefits.map((benefit, index) => <motion.div key={benefit.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="group relative bg-white/[0.03] border border-white/10 rounded-xl p-8 hover:bg-white/[0.06] hover:border-orange/40 transition-all" data-id="element-301" data-mp="3uptp6zlk7kf8" data-mpi={index}>
              <div className="flex items-center justify-center w-14 h-14 rounded-lg bg-orange text-white mb-5 group-hover:scale-110 transition-transform" data-id="element-302" data-mp="320w82zt33to2">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-303" data-mp="1aw2ppsog3jv7">
                {benefit.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-304" data-mp="w7g97nn30m2e">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}